module.exports = __webpack_public_path__ + "static/media/zaistep.0b90e9d6.png";